<template>
    <!--大额返减活动-->
    <div :class="{'activity':true,'mobile':isMobile}">
        <img :src="imgUrl" class="activity-img"/>
    </div>
</template>

<script>
    export default {
        name: "BigDiscountActivity",
        data() {
            return {
                imgUrl: ''
            }
        },
        computed: {
            isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                return flag;
            }
        },
        methods: {
            // 添加判断方法

        },
        mounted() {
            if (this.isMobile) {
                this.imgUrl = '../static/activity/20210325/banner_app.jpg'
            } else {
                this.imgUrl = '../static/activity/20210325/banner_pc.jpg'
            }
        }
    }
</script>

<style scoped lang="scss">
    .activity {
        background-color: transparent;
        width: 100%;
        margin: 0px auto;
        height: 100%;

        &.mobile {
            width: 100%;
        }

        .activity-img {
            width: 100%;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// Promotion.vue?923e2c28